import { Properties, TargetCondition, TargetKey } from "../../model/model"
import ConditionMatcher from "./ConditionMatcher"
import EvaluateRequest from "../EvaluateRequest"
import { EvaluatorContext } from "../evaluator/Evaluator"
import ValueOperatorMatcher from "./ValueOperatorMatcher"
import UserEvent from "../../event/UserEvent"

export interface EventEvaluateRequest extends EvaluateRequest {
  event: UserEvent
}

export default class EventConditionMatcher implements ConditionMatcher {
  constructor(
    private readonly eventValueResolver: EventValueResolver,
    private readonly valueOperatorMatcher: ValueOperatorMatcher
  ) {}

  matches(request: EvaluateRequest, context: EvaluatorContext, condition: TargetCondition): boolean {
    if (!this.isEventEvaluateRequest(request)) {
      return false
    }
    const eventValue = this.eventValueResolver.resolveOrNull(request.event, condition.key)
    return this.valueOperatorMatcher.matches(eventValue, condition.match)
  }

  private isEventEvaluateRequest(request: EvaluateRequest): request is EventEvaluateRequest {
    return (request as EventEvaluateRequest).event !== undefined
  }
}

export class EventValueResolver {
  resolveOrNull(event: UserEvent, key: TargetKey): any {
    switch (key.type) {
      case "EVENT_PROPERTY":
        return this.properties(event)?.[key.name]
      case "USER_ID":
      case "USER_PROPERTY":
      case "HACKLE_PROPERTY":
      case "SEGMENT":
      case "AB_TEST":
      case "FEATURE_FLAG":
      case "COHORT":
        throw new Error(`Unsupported TargetKeyType [${key.type}]`)
    }
  }

  private properties(event: UserEvent): Properties | undefined {
    if (UserEvent.isTrackEvent(event)) {
      return event.event.properties
    }
    if (UserEvent.isExposureEvent(event)) {
      return event.properties
    }
    if (UserEvent.isRemoteConfigEvent(event)) {
      return event.properties
    }
    return undefined
  }
}
